import "src/components/PCPageMgr";import "src/components/Layout";import "src/components/View";import "src/component/script/AggregationScript";import "src/component/script/BaseProps";import "src/component/script/GGEdge";import "src/component/script/StringScript";import "src/component/jj/JImage";import "src/components/Text";import "src/component/jj/JA";import "src/component/script/ExtStyleScript";import "src/component/script/CheckScript";import "src/component/source/SourceStore";import "src/components/Modal";import "src/components/ButtonExt";import "src/component/script/ImmediateScript";import "src/component/script/ClickScript";import "src/component/script/CallbackScript";
        const UILoadingManifest = (key: string) => {
            switch (key) {
                
                default:
                    return null;
            }
        };
        
        UILoadingManifest.PageManifest ={
            home:["PCPage","SourceStore","View","AggregationScript","BaseProps","GGEdge","StringScript","JImage","Modal","ButtonExt","CheckScript","ImmediateScript","Text","ClickScript","CallbackScript","JA","ExtStyleScript"],
        }

        export default UILoadingManifest;